import { Navigate } from 'react-router';

import useAuth from '../hooks/useAuth';
import { useHasPermission } from '../hooks/useHasPermission';

interface ProtectedRouteProps {
  children: JSX.Element;
  moduleName?: string;
  permission?: string;
}

const ProtectedRoute = ({ children, moduleName, permission = 'View' }: ProtectedRouteProps) => {
  const { token, isAuth } = useAuth();
  const hasPermission = useHasPermission(moduleName ?? '', permission);

  if (!isAuth) {
    return <Navigate to="/sign-in" replace />;
  }

  if (!token) {
    const { search, pathname } = window.location;
    sessionStorage.setItem('backUrl', btoa(pathname + search));

    return <Navigate to="/" replace />;
  }

  if (moduleName && !hasPermission) {
    return <Navigate to={moduleName === 'Cases' ? '/manage-account' : '/'} replace />;
  }

  return token ? children : null;
};

export default ProtectedRoute;
